"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const oneEntry_1 = require("../base/oneEntry");
/**
 * Controllers for working with product statuses
 */
class ProductStatusesApi extends oneEntry_1.default {
    constructor(url, token) {
        super(url, token);
        this._url += '/api/content/product-statuses';
    }
    /**
     * Search for all product status objects.
     *
     * @returns Returns an array of product status objects
     */
    async getProductStatuses() {
        const result = await this._fetchGet('');
        return result;
    }
    /**
     * Search for a product status object by identifier.
     *
     * @param {number} [id] - Status id
     *
     * @returns Returns a product status object
     */
    async getProductStatusesById(id) {
        const result = await this._fetchGet(`/${id}`);
        return result;
    }
    /**
     * Search for a product status object by its textual identifier (marker).
     *
     * @param {string} [marker] - Product marker
     *
     * @returns Returns a product status object
     */
    async getProductsByStatusMarker(marker) {
        const result = await this._fetchGet(`/marker/${marker}`);
        return result;
    }
    /**
     * Check the existence of a textual identifier.
     *
     * @param {string} [marker] - Product marker
     *
     * @returns Returns true if the textual identifier (marker) exists or false if it doesn't
     */
    async validateMarker(marker) {
        const result = await this._fetchGet(`/marker-validation/${marker}`);
        return result;
    }
}
exports.default = ProductStatusesApi;
